import React, { useEffect } from 'react';
import { usePersistedStore } from '../../store/persisted-store';
import { Card, Space, Table, Tooltip, Spin, Descriptions } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';


export default function Feedback() {

    const { getCompanyFeedback, business, postCompanyFeedback } = usePersistedStore()
    const currentBusiness = business.currentBusiness;
    const { token } = currentBusiness;
 


    useEffect(() => {
        if (token)
            getCompanyFeedback();
    }, [token])


    const data = business.companyFeedback.data.Feedbacks;
    const loading = business.companyFeedback.loading;

    const columns = [
        {
            title: 'تایید',
            dataIndex: "doneCall",
            ellipsis: true,
            width: 40,
            key: "doneCall",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">

                        <button
                            type="primary" htmltype="submit" className="btn btn-success waves-effect waves-light"
                            onClick={() => {
                                postCompanyFeedback({ Id: record.Id, StatusId: 1 });
                            }}>
                            <Tooltip placement="top" overlayClassName="wizard-tooltip" title="تایید">
                                <i className="bx bx-check-double font-size-14 align-middle "></i>
                            </Tooltip>
                        </button>
                    </Space>
                )
        },
        {
            title: 'عدم تایید',
            dataIndex: "rejected",
            ellipsis: true,
            width: 40,
            key: "rejected",
            render: (_, record) =>
                data.length >= 1 && (
                    <Space size="middle">
                        <button
                            type="primary" htmltype="submit" className="btn btn-danger waves-effect waves-light"
                            onClick={() => {
                                postCompanyFeedback({ Id: record.Id, StatusId: 2 });
                            }}>
                            <Tooltip placement="top" overlayClassName="wizard-tooltip" title="عدم تایید">
                                <i className="fas fa-minus font-size-14 align-middle "></i>
                            </Tooltip>
                        </button>
                    </Space>
                )
        },

        {
            title: 'نام',
            width: 100,
            dataIndex: 'FullName',
            key: "FullName",
        },

        {
            title: "شرکت",
            dataIndex: "CompanyName",
            key: "CompanyName",
            width: 80,
        },

        {
            title: "رشته",
            dataIndex: "BranchName",
            key: "BranchName",
            width: 100,
        },
        {
            title: 'تاریخ ثبت',
            dataIndex: 'CreationDate',
            width: 120,
            key: 'CreationDate',
            render: date => date && strings.getFarsiNum(moment(date).format('jYYYY/jMM/jDD  ساعت: HH:mm'))
        },

    ];

    return (
        <Spin spinning={loading}>
            {data && data.length > 0 ?
                <Card>
                    <Table
                        style={{ overflowX: 'scroll' }}
                        className="custom-table feedback-table"
                        size="middle"
                        bordered
                        columns={columns}
                        loading={loading}
                        rowKey="Id"
                        dataSource={data}
                        scroll={true}
                        expandable={{
                            expandedRowRender: (record) => (
                                <p
                                    style={{
                                        margin: 0,
                                    }}
                                >
                                    {record.Comment}
                                    <Descriptions column={4} bordered size="small" style={{ marginTop: "10px" }}>
                                        <Descriptions.Item label="خسارت پرداختی"> {record.RateDamagesPaid}</Descriptions.Item>
                                        <Descriptions.Item label="پوشش های بیمه"> {record.RateInsuranceCoverage}</Descriptions.Item>
                                        <Descriptions.Item label="حق بیمه"> {record.RateInsurancePremium}</Descriptions.Item>
                                        <Descriptions.Item label="پشتیبانی و خدمات"> {record.RateSupportAndServices}</Descriptions.Item>
                                    </Descriptions>

                                </p>
                            ),
                        }}
                    />
                </Card>
                :
                <Card>
                    <div style={{ textAlign: "center", fontSize: "16px", fontWeight: "bold" }}>کارتابل نظرات خالی است</div>
                </Card>}
        </Spin>
    )
}
